import React from 'react'
import Swal from 'sweetalert2'
import axios from 'axios'

const DeleteProject = (props) => {

    const delProjectID = props.DelID
    const delProjectName = props.DelName

    const handleProjectDelete = () => {
        Swal.fire({
            title: 'Are you sure ?',
            text: `You want to delete projectID = ${delProjectID} & projectName = ${delProjectName}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'red',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${process.env.REACT_APP_BASEURL}/projects/${delProjectID}`)
                    .then(res => {
                        if (res.data.status === "Success") {
                            Swal.fire(
                                'Deleted!',
                                'Project Deleted!',
                                'success'
                            )
                        }
                        else {
                            Swal.fire('Error!', '', 'error')
                        }
                    })
            }
        })
    }

    return (

        <>

            <div className="delete-icon">
                <i className="bi bi-trash3 btn-sm" onClick={handleProjectDelete} />
            </div>

        </>

    )
}

export default DeleteProject
